module.exports = __webpack_public_path__ + "media/country_flags/nr-22a89b5f.png";